import apiClient from './apiClient';

const usersClient = apiClient('users');

const userApi = {
    getMe: async () => {
        const { data } = await usersClient.get('/profile/me');
        return data;
    },
    getMyAvatar: async () => {
        const { data } = await usersClient.get('/profile/me/avatar');
        return data;
    },

    // ── Multi-wallet ──────────────────────────────────────────────────────────
    getWallets: async () => {
        const { data } = await usersClient.get('/profile/me/wallets');
        return data;
    },
    addWallet: async (walletAddress, walletChainId, label) => {
        const { data } = await usersClient.post('/profile/me/wallets', {
            walletAddress,
            walletChainId: walletChainId ? String(walletChainId) : undefined,
            label: label || undefined,
        });
        return data;
    },
    removeWallet: async (walletId) => {
        const { data } = await usersClient.delete(`/profile/me/wallets/${walletId}`);
        return data;
    },
    setPrimaryWallet: async (walletId) => {
        const { data } = await usersClient.patch(`/profile/me/wallets/${walletId}/primary`);
        return data;
    },

    // Legacy single-wallet (обратная совместимость)
    saveWalletAddress: async (walletAddress, walletChainId, label) => {
        return userApi.addWallet(walletAddress, walletChainId, label);
    },
    disconnectWallet: async (walletId) => {
        if (walletId) return userApi.removeWallet(walletId);
        // Если walletId не передан — удаляем все кошельки
        const wallets = await userApi.getWallets();
        await Promise.all(wallets.map(w => userApi.removeWallet(w.id)));
    },
};

export default userApi;
